module.exports = __webpack_public_path__ + "static/media/14UNEP6.1bbe1d45.jpg";